import { Bows } from "../Bow";
import ItemShop from "../Story/ItemShop";
import Shop from "../Story/Shop";
import StoryStorage from "../Storage/StoryStorage";
import PlayerInventoryStorage from "../Storage/PlayerInventoryStorage";
import BackButton from '../GUI/BackButton';
import { isMobileDevice } from "../Utils/device";

export default class ShopScene extends Phaser.Scene {
  private mInvectoryStorage: PlayerInventoryStorage;
  private mPlayerStorage: StoryStorage;

  private mBackground: Phaser.GameObjects.Image;
  private mGold: number;
  private mMoneyIcon: Phaser.GameObjects.Image;
  private mMoneyText: Phaser.GameObjects.Text;
  private mMoneyLabel: Phaser.GameObjects.Text;
  private mBackButton!: BackButton;

  private mCurrentBowFrame: Phaser.GameObjects.Image;
  private mShop: Shop;
  private mCurrentBowName: string;
  private mBowDescriptionText: Phaser.GameObjects.Text;

  constructor() {
    super("ShopScene");

    this.mInvectoryStorage = new PlayerInventoryStorage();
    this.mPlayerStorage = new StoryStorage();
  }

  init() {
    this.mGold = this.mPlayerStorage.GetMoney();
    let shop = new Shop([]);
    let ownedBows = this.mInvectoryStorage.GetOwnedBows();

    Bows.AllBows.forEach((bow) => {
      let path = "images/Bows/" + bow.Name + "_item.png";
      let ownedBow = ownedBows.find((i) => i == bow.Name);
      let owned =
        bow == Bows.BasicBow || bow == Bows.DevBow || ownedBow != undefined;
      let item = new ItemShop(bow.Cost, bow.Name, "", path, owned);
      shop.Items.push(item);
    });

    this.mShop = shop;

    this.mCurrentBowName = this.mInvectoryStorage.GetCurrentBow();
  }

  preload() {
    this.mMoneyText = this.add.text(40, 40, this.mGold.toString(), {
      font: "15px Arial",
      color: "#FFFFFF",
    });
    this.mMoneyLabel = this.add.text(10, 10, "Your Gold:", {
      font: "15px Arial",
      color: "#FFFFFF",
    });
    this.mBowDescriptionText = this.add.text(300, 50, "", {
      font: "16px Arial",
      color: "#000000",
      backgroundColor: "#FFFFFF",
    });
    this.mBowDescriptionText.setVisible(false);

    this.load.image("currentBowFrame", "images/selectionFrame.png");
    this.load.image("moneyIcon", "images/goldIcon.png");
    this.load.image("shopBackground", "images/Scenes/Shop.png");

    this.mShop.Items.forEach((item) => {
      this.load.image(item.Name, item.ImagePath);
      this.load.image(`itemBowFrame_${item.Name}`, "images/shopItemFrame.png");
      this.load.image(
        `shopItemFrameGold_${item.Name}_Owned`,
        "images/shopItemFrameOwned.png"
      );
      this.load.image(
        `shopItemFrameGold_${item.Name}_Gold`,
        "images/shopItemFrameGold.png"
      );
    });

    BackButton.preload(this);
  }

  create() {
    const adjustingGoldTextX = 12;

    let scene = this;
    this.mMoneyIcon = this.add.image(20, 46, "moneyIcon");

    let x = 0;
    let { width, height } = this.sys.game.canvas;

    let halfWidth = width / 3 + 300;
    let halfHeight = height / 2 - 200;

    this.mBackground = scene.add.image(width / 2, height / 2, "shopBackground");
    this.mBackground.setDisplaySize(width, height);
    this.mBackground.setDepth(-1);

    const xStart = 150;
    const xAlignement = 100;
    const yAlignment = 96;

    this.mShop.Items.forEach((item) => {
      item.FrameImage = this.add.image(
        halfWidth + xStart + xAlignement * x,
        halfHeight,
        `itemBowFrame_${item.Name}`
      );

      let goldSuffixName = item.Owned ? "_Owned" : "_Gold";
      item.GoldImage = this.add.image(
        halfWidth + xStart + xAlignement * x,
        halfHeight + yAlignment,
        `shopItemFrameGold_${item.Name}${goldSuffixName}`
      );
      item.Image = this.add.image(
        halfWidth + xStart + xAlignement * x,
        halfHeight,
        item.Name
      );


      let goldText = item.Owned ? "owned" : item.Cost.toString();
      let adjustX = item.Owned ? adjustingGoldTextX : 0;

      item.GoldText = this.add.text(
        halfWidth + xStart + xAlignement * x - 8 - adjustX,
        halfHeight + yAlignment - 8,
        goldText,
        { font: "15px Arial", color: "#FFFFFF" }
      );

      let img = item.Image;
      img.setDepth(9999);
      img
        .setInteractive()
        .on("pointerover", () => {
          scene.mBowDescriptionText.setText(
            scene.generateDescriptionBowText(img)
          );
          scene.mBowDescriptionText.setVisible(true);

          if (!item.Owned) {
            item.GoldText?.setText("Buy?");
          } else {
            img.setScale(1.5, 1.5);
          }
        })
        .on("pointerout", () => {
          if (!item.Owned) {
            item.GoldText?.setText(item.Cost.toString());
          } else {
            img.setScale(1, 1);
          }
        });

      item.GoldImage.setInteractive()
        .on("pointerover", () => {
          if (!item.Owned) {
            item.GoldText?.setText("Buy?");
          }
        })
        .on("pointerout", () => {
          if (!item.Owned) {
            item.GoldText?.setText(item.Cost.toString());
          }
        })
        .on("pointerdown", () => {
          if(item.Owned){
            return;
          }

          let gold = scene.mGold;
          if (gold < item.Cost) {
            scene.mBowDescriptionText.text = "I'm sorry but you don't have enough gold";
            scene.cameras.main.shake(50, new Phaser.Math.Vector2(0.02, 0));
            return;
          }
          gold -= item.Cost;

          item.Owned = true;

          scene.mInvectoryStorage.AddOwnedBows(item.Name);
          scene.mMoneyText.setText(gold.toString());
          scene.mPlayerStorage.SetMoney(gold);
          // Todo: set Exp

          if (item.GoldImage == undefined) {
            return;
          }

          let x = item.GoldImage?.x;
          let y = item.GoldImage?.y;
          item.GoldImage?.destroy();
          let goldSuffixName = item.Owned ? "_Owned" : "_Gold";
          item.GoldImage = this.add.image(
            x,
            y,
            `shopItemFrameGold_${item.Name}${goldSuffixName}`
          );
          if (item.GoldText != undefined) {
            item.GoldText.x -= adjustingGoldTextX;
            item.GoldText?.setText("Owned");
          }
        });

      item.Image.on("pointerdown", () => {
        if (!item.Owned) {
          return;
        }

        this.mCurrentBowFrame.x = item.Image?.x ?? 0;
        this.mCurrentBowFrame.y = item.Image?.y ?? 0;
        this.mInvectoryStorage.SetCurrentBow(item.Name);
        scene.mCurrentBowName = item.Name;
      });

      let bow = Bows.GetBow(item.Name);

      img
        .setData("Name", bow?.Name)
        .setData("Level", bow?.Level)
        .setData("Description", bow?.Description)
        .setData("MinDamage", bow?.MinBaseDamage)
        .setData("MaxDamage", bow?.MaxBaseDamage)
        .setData("Arrows", bow?.MaxArrows)
        .setData("TimeToFull", bow?.TimeToFullPower);
      x++;
    });

    this.mCurrentBowFrame = this.add.image(0, 0, `currentBowFrame`);

    this.mShop.Items.forEach((item: ItemShop, index, arr) => {
      if (item.Name == scene.mCurrentBowName && item.Image != undefined) {
        scene.mCurrentBowFrame.x = item.Image.x;
        scene.mCurrentBowFrame.y = item.Image?.y;
      }
    });

    this.mBackButton = new BackButton(this, "MainMenu"); // default bottom-left
  }

  update() {
    if (this.input.keyboard === null) {
      return;
    }

    var keyObj = this.input.keyboard.addKey("Esc"); // Get key object
    var isDown = keyObj.isDown;
    if (isDown) {
      this.scene.start("MainMenu");
    }
  }

  generateDescriptionBowText(image: Phaser.GameObjects.Image) {
    let descriptions = [
      `Name: ${image.getData("Name")} (${image.getData("Level")})`,
    ];
    image
      .getData("Description")
      .split(",")
      .forEach((l) => descriptions.push(l));
    descriptions.push(
      `Damage: ${image.getData("MinDamage")} - ${image.getData("MaxDamage")}`
    );
    descriptions.push(`Max Arrows: ${image.getData("Arrows")}`);
    descriptions.push(
      `Time to full: ${image.getData("TimeToFull").getSeconds()}.${image
        .getData("TimeToFull")
        .getMilliseconds()} seconds`
    );

    return descriptions;
  }
}
